var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#565a61",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 14c-3.66667 0-4 0-4-5.64 0-6.36.33333-6.36 4-6.36s4 0 4 6.36c0 5.64-.33333 5.64-4 5.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.33325 4.66675h3.33334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 10.0001h1.6667c.2652 0 .5195.1054.7071.2929.1875.1876.2929.4419.2929.7071v.6667c0 .2652.1053.5196.2929.7071.1875.1875.4419.2929.7071.2929s.5195-.1054.7071-.2929c.1875-.1875.2929-.4419.2929-.7071v-5.48667c-.0001-.25316-.0722-.50108-.208-.71477-.1357-.21368-.3295-.3843-.5587-.49189l-2-.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 4.66675v1.62666c.0003.18302.0454.36317.1314.52472.086.16154.2103.29955.3619.40195l1.1734.78"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.f821acf989458dc1fb0b2ffa0f5ccc18.svg";
export { ForwardRef as ReactComponent };